/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useMemo } from "react";
import { useHistory } from "react-router-dom";
import Layout from "./../../global/Layout";
// import { toggleClientRoot } from "./../toggleClientRoute";
import {
  StyledContainer,
  StyledInfoBox,
  StyledInfoText,
  StyledAssetContainer,
  StyledLeftColumn,
  StyledRightColumn,
  StyledPosterSelector,
  StyledButton,
  StyledHashtag,
  StyledDownloadButton,
} from "./styles";
import {
  StyledH3,
  StyledH2,
  StyledHelpText,
} from "../../makealist/routes/common/styles";
import routeNames from "./../../utilities/server/routeNames";

import { getGtmEventClickData } from "../../api/utilities";

const ViewPoster = ({
  isMobile,
  isDataCollected,
  isDataCollectionSkipped,
  isQueueFull,
  history,
  clientContext,
  context,
}) => {
  let { settings } = context.data;
  // toggleClientRoot();
  let {
    h3,
    h2,
    tapAndHold,
    messageOne,
    handle,
    messageTwo,
    hashtag,
    messageThird,
  } = settings.strings.view;

  const isClient = typeof window === "object";
  if (isClient) {
    if (!isDataCollected && !isDataCollectionSkipped)
      history.push(routeNames.home);

    const [activePoster, setActivePoster] = useState("1");
    const hiddenLinkRef = useRef(null);

    const downloadImage = (image) => {
      const hiddenLink = hiddenLinkRef.current;
      hiddenLink.href = image;
      hiddenLink.download = "MyFive";
      hiddenLink.click();
    };

    const renderImages = useMemo(
      () =>
        Array(2)
          .fill(0)
          .map((_, index) => index)
          .map((it) =>
            (sessionStorage || localStorage).getItem(
              `asset-${it === 0 ? "square" : "rect"}`
            )
          ),
      []
    );

    return (
      <>
        {isQueueFull && (
          <StyledContainer isMobile={isMobile}>
            <StyledH3>{h3}</StyledH3>
            <StyledH2 customstyles={{ marginBottom: "0" }}>{h2}</StyledH2>
            <StyledHelpText customstyles={{ marginBottom: "53px" }}>
              {messageOne}
              <StyledHashtag>{handle}</StyledHashtag>
              {messageTwo}
              <StyledHashtag>{hashtag}</StyledHashtag>.
              <br />
              <br />
              {messageThird}
            </StyledHelpText>
            <StyledAssetContainer isMobile={isMobile}>
              {isMobile && (
                <>
                  {activePoster === "1" && (
                    <StyledLeftColumn isMobile={isMobile}>
                      <img
                        alt="squarePoster"
                        src={renderImages[0]}
                        height="334px"
                      />
                    </StyledLeftColumn>
                  )}
                  {activePoster === "2" && (
                    <StyledRightColumn isMobile={isMobile}>
                      <img
                        alt="rectPoster"
                        src={renderImages[1]}
                        height="334px"
                      />
                    </StyledRightColumn>
                  )}
                </>
              )}
              {!isMobile && (
                <>
                  <StyledLeftColumn isMobile={isMobile}>
                    <img
                      alt="squarePoster"
                      src={renderImages[0]}
                      height="355px"
                    />
                    <StyledDownloadButton
                      onClick={(e) => {
                        e.preventDefault();
                        downloadImage(renderImages[0]);
                        getGtmEventClickData(e.currentTarget);
                      }}
                      data-track-hit-type="event"
                      data-track-event-category="View Poster - Download Large"
                      data-track-event-action="click"
                      data-track-event-label={"makealist/view"}
                      data-track-event-value={4}
                    >
                      DOWNLOAD
                    </StyledDownloadButton>
                  </StyledLeftColumn>
                  <StyledRightColumn isMobile={isMobile}>
                    <img alt="rectPoster" src={renderImages[1]} height="355" />
                    <StyledDownloadButton
                      onClick={(e) => {
                        e.preventDefault();
                        downloadImage(renderImages[1]);
                        getGtmEventClickData(e.currentTarget);
                      }}
                      data-track-hit-type="event"
                      data-track-event-category="View Poster - Download Small"
                      data-track-event-action="click"
                      data-track-event-label={""}
                      data-track-event-value={4}
                    >
                      DOWNLOAD
                    </StyledDownloadButton>
                  </StyledRightColumn>
                  <a ref={hiddenLinkRef} style={{ display: "hidden" }}>
                    {" "}
                  </a>
                </>
              )}
            </StyledAssetContainer>
            {isMobile && (
              <StyledPosterSelector>
                <StyledButton
                  active={activePoster === "1"}
                  onClick={() => setActivePoster("1")}
                >
                  <img alt="squarePoster" src={renderImages[0]} height="50px" />
                </StyledButton>
                <StyledButton
                  active={activePoster === "2"}
                  onClick={() => setActivePoster("2")}
                >
                  <img alt="rectPoster" src={renderImages[1]} height="50px" />
                </StyledButton>
              </StyledPosterSelector>
            )}
            {}
            <StyledInfoBox>
              <StyledInfoText>
                <>
                  {isMobile && <>{tapAndHold}</>} <br />
                </>
              </StyledInfoText>
            </StyledInfoBox>
          </StyledContainer>
        )}
      </>
    );
  }
  return null;
};

export default ({ location: { state }, clientContext, context, ...rest }) => {
  const isClient = typeof window === "object";
  const history = useHistory();
  let { isMobile } = clientContext;
  return <Layout
    context={context}
    clientContext={clientContext}
    newsletter={{
      showNewsletter: false,
      checkCookie: true,
      delayShowNewsletter: 5000,
      checkCookieCount: 2,
    }}
    isHomepage={false}
  >
    <ViewPoster
      isMobile={isMobile}
      {...state}
      history={history}
      clientContext={clientContext}
      context={context}
      {...rest}
    />
  </Layout>;
};
